module.exports = __webpack_public_path__ + "static/img/down_bg_ar.730713de.png";